import { MesureStation } from './mesure-station';
import { Substrat } from './substrat';
import { LocalisationStation } from '../Shared/localisation-station';

export class Process {
    id: number; // For IndexedDB
    interventionId: number;

    Code: string;
    TracabiliteCode: string;
    MesureStation: MesureStation = new MesureStation();
    Substrats: Substrat[];
    LocalisationStation: LocalisationStation = new LocalisationStation();
    GroupementPrelevement: boolean;


    static mapFromJSON(json): Process {
        const p = new Process();

        p.Code = json.code;
        p.TracabiliteCode = json.tracabilite;
        p.GroupementPrelevement = json.groupementPrelevement;

        if (json.mesureStation) {
            p.MesureStation = MesureStation.mapFromJSON(json.mesureStation);
        }

        // TO REMOVE ?
        if (json.substrats) {
            p.Substrats = json.substrats.map(jsonItem => Substrat.mapFromJSON(jsonItem));
        }

        if (json.localisationStation) {
            p.LocalisationStation = LocalisationStation.mapFromJSON(json.localisationStation);
        }
        return p;
    }
}
